var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"group-header",attrs:{"justify-space-between":""}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.summaryText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }